import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  Select,
  DatePicker,
  Tabs,
  Checkbox,
  Card,
  Divider,
  Tag,
} from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import {
  country,
  contacts,
  title,
  grade,
  currency,
  contactCategory,
  contactSource,
  vatCountry,
  vatEmirates,
  designation,
  legalCompany,
  companyAll,
  vwRentalTcList,
} from "../../../constants/url";
import moment from "moment";

class Contact extends React.Component {
  _isMounted = false;
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    countryData: {
      list: [],
      selectedIndex: null,
    },
    nationalityData: {
      list: [],
      selectedIndex: null,
    },
    titleData: {
      list: [],
      selectedIndex: null,
    },
    gradeData: {
      list: [],
      selectedIndex: null,
    },
    designationData: {
      list: [],
      selectedIndex: null,
    },
    statusData: {
      list: [],
      selectedIndex: null,
    },
    currencyData: {
      list: [],
      selectedIndex: null,
    },
    legalCompanyData: {
      list: [],
      selectedIndex: null,
    },
    companyData: {
      list: [],
      selectedIndex: null,
    },
    categoryData: {
      list: [],
      selectedIndex: null,
    },
    subCategoryData: {
      list: [],
      selectedIndex: null,
    },
    sourceData: {
      list: [],
      selectedIndex: null,
    },
    vatCountryData: {
      list: [],
      selectedIndex: null,
    },
    vatEmiratesData: {
      list: [],
      selectedIndex: null,
    },
    isEmployee: false,
    tableData: {
      list: [],
      loading: true,
      currentPage: 1,
      pageSize: 20,
      total: 20,
    },
    contactInfo: { contracts: [] },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 80,
    },

    {
      title: "SysCode",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "UserCode",
      dataIndex: "UserCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "Contact Name",
      dataIndex: "ContactName",
      key: "ContactName",
      align: "center",
      width: 150,
      sorter: (a, b) => a.ContactName.localeCompare(b.ContactName),
    },
    {
      title: "Category",
      dataIndex: ["ContactCategory", "UserName"],
      key: "ContactName",
      align: "center",
      width: 120,
      sorter: (a, b) =>
        (a.ContactCategory || {}).UserName.localeCompare(
          (b.ContactCategory || {}).UserName
        ),
    },
    {
      title: "Sub Category",
      dataIndex: ["ContactSubCategory", "UserName"],
      key: "ContactName",
      align: "center",
      width: 120,
      sorter: (a, b) =>
        (a.ContactSubCategory || {}).UserName.localeCompare(
          (b.ContactSubCategory || {}).UserName
        ),
    },
    {
      title: "Created At",
      dataIndex: "DateCreated",
      key: "DateCreated",
      align: "center",
      width: 150,
      render: (value) => (value ? value.split("T")[0] : "N/A"),
      sorter: (a, b) => new Date(a.DateCreated) - new Date(b.DateCreated),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 110,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={async () => {
                const tmpList = [];
                let state = this.state;
                // populate information for this contact
                Object.keys(item).map((key) => {
                  tmpList.push({ name: key, value: item[key] });
                  return key;
                });
                tmpList.push({
                  name: "PassportExpDate",
                  value: item.PassportExpDate
                    ? moment(item.PassportExpDate)
                    : null,
                });
                tmpList.push({
                  name: "PassportIssueDate",
                  value: item.PassportIssueDate
                    ? moment(item.PassportIssueDate)
                    : null,
                });
                tmpList.push({
                  name: "UAEIdExpDate",
                  value: item.UAEIdExpDate ? moment(item.UAEIdExpDate) : null,
                });
                tmpList.push({
                  name: "DateofBirth",
                  value: item.DateofBirth ? moment(item.DateofBirth) : null,
                });
                state.isEmployee = item.IsEmployee;
                // populate and override especially the dropdown informations
                for (let title of state.titleData.list)
                  if (
                    item.Title.toLowerCase() === title.UserName.toLowerCase()
                  ) {
                    state.titleData.selectedIndex =
                      state.titleData.list.indexOf(title);
                    tmpList.push({
                      name: "Title",
                      value:
                        "title+-" +
                        state.titleData.list.indexOf(title) +
                        "+-" +
                        title.UserName,
                    });
                    break;
                  }
                if (state.titleData.selectedIndex === null)
                  tmpList.push({ name: "Title", value: null });
                for (let country of state.countryData.list)
                  if (item.CountryID === country.CountryID) {
                    state.countryData.selectedIndex =
                      state.countryData.list.indexOf(country);
                    tmpList.push({
                      name: "CountryID",
                      value:
                        "country+-" +
                        state.countryData.list.indexOf(country) +
                        "+-" +
                        country.UserName,
                    });
                    break;
                  }
                // reset country form if none selected or doesnot match
                if (state.countryData.selectedIndex === null)
                  tmpList.push({ name: "NationalityID", value: null });
                for (let country of state.nationalityData.list)
                  if (item.NationalityID === country.CountryID) {
                    state.nationalityData.selectedIndex =
                      state.nationalityData.list.indexOf(country);
                    tmpList.push({
                      name: "NationalityID",
                      value:
                        "nationality+-" +
                        state.nationalityData.list.indexOf(country) +
                        "+-" +
                        country.UserName,
                    });
                    break;
                  }
                if (state.nationalityData.selectedIndex === null)
                  tmpList.push({ name: "NationalityID", value: null });
                for (let grade of state.gradeData.list)
                  if (item.GradeID === grade.GradeID) {
                    state.gradeData.selectedIndex =
                      state.gradeData.list.indexOf(grade);
                    tmpList.push({
                      name: "GradeID",
                      value:
                        "grade+-" +
                        state.gradeData.list.indexOf(grade) +
                        "+-" +
                        grade.UserName,
                    });
                    break;
                  }
                if (state.gradeData.selectedIndex === null)
                  tmpList.push({ name: "GradeID", value: null });
                for (let company of state.companyData.list)
                  if (item.CompanyID === company.CompanyID) {
                    state.companyData.selectedIndex =
                      state.companyData.list.indexOf(company);
                    tmpList.push({
                      name: "CompanyID",
                      value:
                        "company+-" +
                        state.companyData.list.indexOf(company) +
                        "+-" +
                        company.CompanyName,
                    });
                    break;
                  }
                if (state.companyData.selectedIndex === null)
                  tmpList.push({ name: "CompanyID", value: null });
                for (let company of state.legalCompanyData.list)
                  if (item.LegalCompany_ID === company.LegalCompanyID) {
                    state.legalCompanyData.selectedIndex =
                      state.legalCompanyData.list.indexOf(company);
                    tmpList.push({
                      name: "LegalCompany_ID",
                      value:
                        "legalCompany+-" +
                        state.legalCompanyData.list.indexOf(company) +
                        "+-" +
                        company.CompanyName,
                    });
                    break;
                  }
                if (state.legalCompanyData.selectedIndex === null)
                  tmpList.push({ name: "LegalCompany_ID", value: null });
                for (let status of state.statusData.list)
                  if (
                    Number(item.ActiveStatus) === status.ContactActiveStatusId
                  ) {
                    state.statusData.selectedIndex =
                      state.statusData.list.indexOf(status);
                    tmpList.push({
                      name: "ActiveStatus",
                      value:
                        "status+-" +
                        state.statusData.list.indexOf(status) +
                        "+-" +
                        status.UserName,
                    });
                    break;
                  }
                if (state.statusData.selectedIndex === null)
                  tmpList.push({ name: "ActiveStatus", value: null });
                for (let currency of state.currencyData.list)
                  if (item.CurrencyID === currency.CurrencyID) {
                    state.currencyData.selectedIndex =
                      state.currencyData.list.indexOf(currency);
                    tmpList.push({
                      name: "CurrencyID",
                      value:
                        "currency+-" +
                        state.currencyData.list.indexOf(currency) +
                        "+-" +
                        currency.UserName,
                    });
                    break;
                  }
                if (state.currencyData.selectedIndex === null)
                  tmpList.push({ name: "CurrencyID", value: null });
                for (let category of state.categoryData.list)
                  if (item.ContactCategoryID === category.ContactCategoryID) {
                    state.categoryData.selectedIndex =
                      state.categoryData.list.indexOf(category);
                    tmpList.push({
                      name: "ContactCategoryID",
                      value:
                        "category+-" +
                        state.categoryData.list.indexOf(category) +
                        "+-" +
                        category.UserName,
                    });
                    if (state.categoryData.selectedIndex !== null)
                      state.subCategoryData.list =
                        state.categoryData.list[
                          state.categoryData.list.indexOf(category)
                        ].ContactSubCategories || [];
                    break;
                  }
                if (state.categoryData.selectedIndex === null)
                  tmpList.push({ name: "ContactCategoryID", value: null });
                for (let subCategory of state.subCategoryData.list)
                  if (
                    item.ContactSubCategoryID ===
                    subCategory.ContactSubCategoryID
                  ) {
                    state.subCategoryData.selectedIndex =
                      state.subCategoryData.list.indexOf(subCategory);
                    tmpList.push({
                      name: "ContactSubCategoryID",
                      value:
                        "subCategory+-" +
                        state.subCategoryData.list.indexOf(subCategory) +
                        "+-" +
                        subCategory.UserName,
                    });
                    break;
                  }
                if (state.subCategoryData.selectedIndex === null)
                  tmpList.push({ name: "ContactSubCategoryID", value: null });
                for (let source of state.sourceData.list)
                  if (item.ContactSourceID === source.ContactSourceID) {
                    state.sourceData.selectedIndex =
                      state.sourceData.list.indexOf(source);
                    tmpList.push({
                      name: "ContactSourceID",
                      value:
                        "source+-" +
                        state.sourceData.list.indexOf(source) +
                        "+-" +
                        source.ContactName,
                    });
                    break;
                  }
                if (state.sourceData.selectedIndex === null)
                  tmpList.push({ name: "ContactSourceID", value: null });
                for (let vatCountry of state.vatCountryData.list)
                  if (item.VAT_Country_Id === vatCountry.VAT_CountryId) {
                    state.vatCountryData.selectedIndex =
                      state.vatCountryData.list.indexOf(vatCountry);
                    tmpList.push({
                      name: "VAT_Country_Id",
                      value:
                        "vatCountry+-" +
                        state.vatCountryData.list.indexOf(vatCountry) +
                        "+-" +
                        vatCountry.VAT_Country,
                    });
                    break;
                  }
                if (state.vatCountryData.selectedIndex === null)
                  tmpList.push({ name: "DesignationID", value: null });
                for (let designation of state.designationData.list)
                  if (item.DesignationID === designation.DesignationID) {
                    state.designationData.selectedIndex =
                      state.designationData.list.indexOf(designation);
                    tmpList.push({
                      name: "DesignationID",
                      value:
                        "designation+-" +
                        state.designationData.list.indexOf(designation) +
                        "+-" +
                        designation.UserName,
                    });
                    break;
                  }
                if (state.designationData.selectedIndex === null)
                  tmpList.push({ name: "DesignationID", value: null });
                for (let vatEmirates of state.vatEmiratesData.list)
                  if (item.VAT_Emirate_Id === vatEmirates.VAT_EmirateId) {
                    state.vatEmiratesData.selectedIndex =
                      state.vatEmiratesData.list.indexOf(vatEmirates);
                    tmpList.push({
                      name: "VAT_Emirate_Id",
                      value:
                        "vatEmirates+-" +
                        state.vatEmiratesData.list.indexOf(vatEmirates) +
                        "+-" +
                        vatEmirates.VAT_Emirate,
                    });
                    break;
                  }
                if (state.vatEmiratesData.selectedIndex === null)
                  tmpList.push({ name: "VAT_Emirate_Id", value: null });
                state.editFormFields = tmpList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(contacts + "/" + item.ContactID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      countryData: {
        list: [],
        selectedIndex: null,
      },
      nationalityData: {
        list: [],
        selectedIndex: null,
      },
      titleData: {
        list: [],
        selectedIndex: null,
      },
      gradeData: {
        list: [],
        selectedIndex: null,
      },
      designationData: {
        list: [],
        selectedIndex: null,
      },
      statusData: {
        list: [],
        selectedIndex: null,
      },
      currencyData: {
        list: [],
        selectedIndex: null,
      },
      companyData: {
        list: [],
        selectedIndex: null,
      },
      legalCompanyData: {
        list: [],
        selectedIndex: null,
      },
      categoryData: {
        list: [],
        selectedIndex: null,
      },
      subCategoryData: {
        list: [],
        selectedIndex: null,
      },
      mainContactData: {
        list: [],
        selectedIndex: null,
      },
      sourceData: {
        list: [],
        selectedIndex: null,
      },
      vatCountryData: {
        list: [],
        selectedIndex: null,
      },
      vatEmiratesData: {
        list: [],
        selectedIndex: null,
      },
      isEmployee: false,
      tableData: {
        list: this.state.tableData.list,
        loading: false,
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      contactInfo: { contracts: [] },
    };
    await axiosInstance
      .get(
        contacts +
          "?offset=" +
          (state.tableData.currentPage - 1) * state.tableData.pageSize +
          "&limit=" +
          state.tableData.pageSize
      )
      .then((res) => {
        if (res.data.success) {
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows.map((data, index) => {
            data.SN =
              (state.tableData.currentPage - 1) * state.tableData.pageSize +
              1 +
              index;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(country)
      .then((res) => {
        if (res.data.success) {
          state.countryData.list = res.data.message;
          state.nationalityData.list = res.data.message;
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(title)
      .then((res) => {
        if (res.data.success) state.titleData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(grade)
      .then((res) => {
        if (res.data.success) state.gradeData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(designation)
      .then((res) => {
        if (res.data.success) state.designationData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contacts + "/activeStatus")
      .then((res) => {
        if (res.data.success) state.statusData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(currency)
      .then((res) => {
        if (res.data.success) state.currencyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contactCategory)
      .then((res) => {
        if (res.data.success) state.categoryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contactSource)
      .then((res) => {
        if (res.data.success) state.sourceData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(vatCountry)
      .then((res) => {
        if (res.data.success) state.vatCountryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(vatEmirates)
      .then((res) => {
        if (res.data.success) state.vatEmiratesData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.legalCompanyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(companyAll)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message.rows;
      })
      .catch(() => {});
    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        values.Title = values.Title.split("+-")[2];
        values.FirstName = values.FirstName.trim();
        values.MiddleName = (values.MiddleName || "").trim();
        values.LastName = (values.LastName || "").trim();
        values.ContactName = (
          values.FirstName +
          " " +
          (values.MiddleName || "") +
          " " +
          (values.LastName || "")
        ).trim();
        if (values.CountryID)
          values.CountryID = Number(
            this.state.countryData.list[values.CountryID.split("+-")[1]]
              .CountryID
          );
        if (values.NationalityID)
          values.NationalityID = Number(
            this.state.countryData.list[values.NationalityID.split("+-")[1]]
              .CountryID
          );
        if (values.GradeID)
          values.GradeID = Number(
            this.state.gradeData.list[values.GradeID.split("+-")[1]].GradeID
          );
        if (values.LegalCompany_ID)
          values.LegalCompany_ID = Number(
            this.state.legalCompanyData.list[
              values.LegalCompany_ID.split("+-")[1]
            ].LegalCompanyID
          );
        if (values.CompanyID)
          values.CompanyID = Number(
            this.state.companyData.list[values.CompanyID.split("+-")[1]]
              .CompanyID
          );
        if (values.ActiveStatus)
          values.ActiveStatus = Number(
            this.state.statusData.list[values.ActiveStatus.split("+-")[1]]
              .ContactActiveStatusId
          );
        if (values.CurrencyID)
          values.CurrencyID = Number(
            this.state.currencyData.list[values.CurrencyID.split("+-")[1]]
              .CurrencyID
          );
        if (values.ContactCategoryID)
          values.ContactCategoryID = Number(
            this.state.categoryData.list[
              values.ContactCategoryID.split("+-")[1]
            ].ContactCategoryID
          );
        if (values.ContactSubCategoryID)
          values.ContactSubCategoryID = Number(
            this.state.subCategoryData.list[
              values.ContactSubCategoryID.split("+-")[1]
            ].ContactSubCategoryID
          );
        values.IsEmployee = this.state.isEmployee;
        if (values.ContactSourceID)
          values.ContactSourceID = Number(
            this.state.sourceData.list[values.ContactSourceID.split("+-")[1]]
              .ContactSourceID
          );
        if (values.DesignationID)
          values.DesignationID = Number(
            this.state.designationData.list[values.DesignationID.split("+-")[1]]
              .DesignationID
          );
        if (values.VAT_Country_Id)
          values.VAT_Country_Id = Number(
            this.state.vatCountryData.list[values.VAT_Country_Id.split("+-")[1]]
              .VAT_CountryId
          );
        if (values.VAT_Emirate_Id)
          values.VAT_Emirate_Id = Number(
            this.state.vatEmiratesData.list[
              values.VAT_Emirate_Id.split("+-")[1]
            ].VAT_EmirateId
          );
        await (this.state.editFormFields.length
          ? axiosInstance.put(contacts, values)
          : axiosInstance.post(contacts, values)
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch((err) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  onChange = (value) => {
    if (!value) return;
    let type, theIndex;
    type = value.split("+-")[0];
    theIndex = value.split("+-")[1];
    switch (type) {
      case "category":
        this.setState({
          categoryData: {
            list: this.state.categoryData.list,
            selectedIndex: theIndex,
          },
          subCategoryData: {
            list:
              this.state.categoryData.list[theIndex].ContactSubCategories || [],
            selectedIndex: null,
          },
        });
        break;
      default:
        break;
    }
  };

  onSearch = () => {
    let state = this.state;
    state.tableData.loading = true;
    this.setState(state);
    state.tableData.loading = false;
    axiosInstance
      .get(
        contacts +
          "?offset=" +
          (state.tableData.currentPage - 1) * state.tableData.pageSize +
          "&limit=" +
          state.tableData.pageSize
      )
      .then((res) => {
        if (res.data.success) {
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows.map((data, index) => {
            data.SN =
              (state.tableData.currentPage - 1) * state.tableData.pageSize +
              1 +
              index;
            data.key = index;
            return data;
          });
        }
        this.setState(state);
      })
      .catch(() => {
        this.setState(state);
      });
  };

  displayContactInfo = (contactInfo) => {
    let state = this.state;
    state.contactInfo = { ...contactInfo, contracts: [] };
    this.setState(state);
    axiosInstance
      .post(vwRentalTcList, {
        attributes: [
          "CompanyID",
          "LegalCompany_ID",
          "LegalcompanyName",
          "Division",
          "Division_ID",
          "ProjectID",
          "ProjectName",
          "BuildingID",
          "BuildingName",
          "UnitID",
          "UnitNo",
        ],
        where: {
          TenantID: contactInfo.ContactID,
          TenantType: "I",
          // TCStatus: "Active",
        },
      })
      .then((res) => {
        /**
         * currentTCNoIndex for identifying index of the
         * contract that a tenant is logged in with.
         */
        if (res.data.success) {
          state.contactInfo.contracts = res.data.message.map(
            (contract, index) => {
              contract.key = index;
              contract.SN = index + 1;
              contract.TCDate = contract.TCDate.split("T")[0];
              contract.TCFromDate = contract.TCFromDate.split("T")[0];
              contract.TCToDate = contract.TCToDate.split("T")[0];
              return contract;
            }
          );
        } else
          notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong!",
          });
        this.setState(state);
      })
      .catch(() => {
        this.setState(state);
      });
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Contact"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                style={{ borderRadius: 20 }}
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
            requiredMark
          >
            <Form.Item
              key="ContactID"
              name="ContactID"
              label="ContactID"
              labelAlign="left"
              labelCol={{ span: 24 }}
              hidden
              rules={[{ required: false, message: "Please enter contact id" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UserCode"
              name="UserCode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter user code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Title"
              name="Title"
              label="Title"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select title" }]}
            >
              <Select
                showSearch
                placeholder="Select title"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.titleData.list.map((title, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"title+-" + index + "+-" + title.UserName}
                    >
                      {title.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="FirstName"
              name="FirstName"
              label="FirstName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter first name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="MiddleName"
              name="MiddleName"
              label="MiddleName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter middle name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="LastName"
              name="LastName"
              label="LastName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter last name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="NationalityID"
              name="NationalityID"
              label="Nationality"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select origin country" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.nationalityData.list.map((country, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"nationality+-" + index + "+-" + country.UserName}
                    >
                      {country.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="DateofBirth"
              name="DateofBirth"
              label="Date of birth"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please select date of birth",
                },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="PassportNo"
              name="PassportNo"
              label="PassportNo"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please enter passport number" },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="PassportIssueDate"
              name="PassportIssueDate"
              label="Passport Issue Date"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select date of passport issue",
                },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="PassportExpDate"
              name="PassportExpDate"
              label="Passport Expiry Date"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select date of passport expiry",
                },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="PassportPlaceOfIssue"
              name="PassportPlaceOfIssue"
              label="Place of issue"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter passport place of issue",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UAEId"
              name="UAEId"
              label="UAE ID"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter uae id" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UAEIdExpDate"
              name="UAEIdExpDate"
              label="UAE ID Expiry Date"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select date of uae id expiry",
                },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="VisaNo"
              name="VisaNo"
              label="VisaNo"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter visa number" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Mobile1"
              name="Mobile1"
              label="Mobile1"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please enter mobile number" },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="LandlineOffice"
              name="LandlineOffice"
              label="Office number"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter office phone number",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="LandlineHome"
              name="LandlineHome"
              label="Home number"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please enter home phone number" },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="EmailID"
              name="EmailID"
              label="Email"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please enter email address" },
              ]}
            >
              <Input type="email"></Input>
            </Form.Item>
            <Form.Item
              key="Website"
              name="Website"
              label="Website"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter Website" }]}
            >
              <Input type="url"></Input>
            </Form.Item>
            <Form.Item
              key="Fax"
              name="Fax"
              label="Fax"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter Fax" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="PostalCode"
              name="PostalCode"
              label="P.O. Box"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter P.O Box" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="ActiveStatus"
              name="ActiveStatus"
              label="Active Status"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select active status" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select status"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.statusData.list.map((status, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"status+-" + index + "+-" + status.UserName}
                    >
                      {status.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CountryID"
              name="CountryID"
              label="Resident Country"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select resident country" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.countryData.list.map((country, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"country+-" + index + "+-" + country.UserName}
                    >
                      {country.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CurrencyID"
              name="CurrencyID"
              label="Currency"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select currency" }]}
            >
              <Select
                showSearch
                placeholder="Select currency"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.currencyData.list.map((currency, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"currency+-" + index + "+-" + currency.UserName}
                    >
                      {currency.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ContactCategoryID"
              name="ContactCategoryID"
              label="Category"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select category" }]}
            >
              <Select
                showSearch
                placeholder="Select category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.categoryData.list.map((category, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"category+-" + index + "+-" + category.UserName}
                    >
                      {category.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ContactSubCategoryID"
              name="ContactSubCategoryID"
              label="SubCategory"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select subcategory" }]}
            >
              <Select
                showSearch
                placeholder="Select sub category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.subCategoryData.list.map((category, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"subCategory+-" + index + "+-" + category.UserName}
                    >
                      {category.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="IsEmployee"
              name="IsEmployee"
              label="Is Employee"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select type" }]}
            >
              <Checkbox
                checked={this.state.isEmployee}
                onChange={(e) =>
                  this.setState({ isEmployee: e.target.checked })
                }
              ></Checkbox>
            </Form.Item>
            <Form.Item
              key="LegalCompany_ID"
              name="LegalCompany_ID"
              label="Legal Company"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select company" }]}
            >
              <Select
                showSearch
                placeholder="Select company"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.legalCompanyData.list.map((company, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "legalCompany+-" + index + "+-" + company.CompanyName
                      }
                    >
                      {company.CompanyName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CompanyID"
              name="CompanyID"
              label="Company"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select company" }]}
            >
              <Select
                showSearch
                placeholder="Select company"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.companyData.list.map((company, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"company+-" + index + "+-" + company.CompanyName}
                    >
                      {company.CompanyName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              hidden
              key="ContactSourceID"
              name="ContactSourceID"
              label="Source"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select source",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select source"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.sourceData.list.map((source, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"source+-" + index + "+-" + source.ContactName}
                    >
                      {source.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="DesignationID"
              name="DesignationID"
              label="Designation"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select designation",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select designation"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.designationData.list.map((designation, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "designation+-" + index + "+-" + designation.UserName
                      }
                    >
                      {designation.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="GradeID"
              name="GradeID"
              label="Grade"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select grade" }]}
            >
              <Select
                showSearch
                placeholder="Select grade"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.gradeData.list.map((grade, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"grade+-" + index + "+-" + grade.UserName}
                    >
                      {grade.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="PrincipalAddress"
              name="PrincipalAddress"
              label="Physical Address"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter physical address",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Remarks"
              name="Remarks"
              label="Remarks"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter remarks",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="VAT" key="1">
                <Form.Item
                  key="VAT_Regd_No"
                  name="VAT_Regd_No"
                  label="VAT Registration No."
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter VAT registration number",
                    },
                  ]}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item
                  key="VAT_Country_Id"
                  name="VAT_Country_Id"
                  label="VAT Local"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select VAT local",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select local"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.vatCountryData.list.map((vatCountry, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={
                            "vatCountry+-" +
                            index +
                            "+-" +
                            vatCountry.VAT_Country
                          }
                        >
                          {vatCountry.VAT_Country}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  key="VAT_Emirate_Id"
                  name="VAT_Emirate_Id"
                  label="VAT Emirates"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select VAT emirates",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select emirates"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.vatEmiratesData.list.map(
                      (vatEmirates, index) => {
                        return (
                          <Select.Option
                            key={index}
                            value={
                              "vatEmirates+-" +
                              index +
                              "+-" +
                              vatEmirates.VAT_Emirate
                            }
                          >
                            {vatEmirates.VAT_Emirate}
                          </Select.Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Doc Expiry" key="2" disabled></Tabs.TabPane>
            </Tabs>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Contact</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Row gutter={[12, 12]}>
          {this.state.contactInfo.ContactID ? (
            <Col
              {...(this.state.contactInfo.ContactID
                ? { xs: 24, sm: 24, md: 24, lg: 10 }
                : { xs: 24, sm: 24, md: 24, lg: 0 })}
              // style={{ padding: 15 }}
            >
              <Card
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
                title={
                  <h3 style={{ textAlign: "center" }}>
                    {(this.state.contactInfo.Title || "") +
                      " " +
                      this.state.contactInfo.ContactName}
                  </h3>
                }
                bodyStyle={{
                  padding: 10,
                  overflowY: "scroll",
                  overflowX: "hidden",
                  maxHeight: window.innerHeight - 210,
                }}
              >
                {this.state.contactInfo.ContactID ? (
                  <Row>
                    {this.state.contactInfo.FirstName ? (
                      <Col span={24}>
                        <h4>
                          First Name:{" " + this.state.contactInfo.FirstName}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.MiddleName ? (
                      <Col span={24}>
                        <h4>
                          Middle Name:{" " + this.state.contactInfo.MiddleName}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.LastName ? (
                      <Col span={24}>
                        <h4>
                          Last Name:{" " + this.state.contactInfo.LastName}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.DateofBirth ? (
                      <Col span={24}>
                        <h4>
                          Date Of Birth:
                          {" " +
                            this.state.contactInfo.DateofBirth.split("T")[0]}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.NationalityID ? (
                      <Col span={24}>
                        <h4>
                          Nationality:{" "}
                          {(
                            this.state.nationalityData.list.filter(
                              (nationality) =>
                                nationality.CountryID ===
                                this.state.contactInfo.NationalityID
                            )[0] || {}
                          ).UserName || "N/A"}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.ContactAddress ? (
                      <Col span={24}>
                        <h4>
                          Contact Address:
                          {" " + this.state.contactInfo.ContactAddress}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Mobile1 ? (
                      <Col span={24}>
                        <h4>
                          Mobile:
                          {" " + this.state.contactInfo.Mobile1}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.LandlineHome ? (
                      <Col span={24}>
                        <h4>
                          Landline Home:
                          {" " + this.state.contactInfo.LandlineHome}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.LandlineOffice ? (
                      <Col span={24}>
                        <h4>
                          Landline Office:
                          {" " + this.state.contactInfo.LandlineOffice}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.EmailID ? (
                      <Col span={24}>
                        <h4>
                          Email:
                          {" " + this.state.contactInfo.EmailID}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.PassportNo ? (
                      <Col span={24}>
                        <h4>
                          Passport No.:
                          {" " + this.state.contactInfo.PassportNo}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.PassportIssueDate ? (
                      <Col span={24}>
                        <h4>
                          Passport Issued Date:
                          {" " +
                            this.state.contactInfo.PassportIssueDate.split(
                              "T"
                            )[0]}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.PassportExpDate ? (
                      <Col span={24}>
                        <h4>
                          Passport Expiry Date:
                          {" " +
                            this.state.contactInfo.PassportExpDate.split(
                              "T"
                            )[0]}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.PassportPlaceOfIssue ? (
                      <Col span={24}>
                        <h4>
                          Passport Place Of Issue:
                          {" " + this.state.contactInfo.PassportPlaceOfIssue}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.UAEId ? (
                      <Col span={24}>
                        <h4>
                          UAE ID:
                          {" " + this.state.contactInfo.UAEId}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.UAEIdExpDate ? (
                      <Col span={24}>
                        <h4>
                          UAE ID Expiry Date:
                          {" " +
                            this.state.contactInfo.UAEIdExpDate.split("T")[0]}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Remarks ? (
                      <Col span={24}>
                        <h4>
                          Remarks:
                          {" " + this.state.contactInfo.Remarks}
                        </h4>
                      </Col>
                    ) : null}
                  </Row>
                ) : null}
                {this.state.contactInfo.contracts.length ? (
                  <>
                    <Row>
                      <Col span={24}>
                        <Divider orientation="left">Contracts</Divider>
                      </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                      {this.state.contactInfo.contracts.map((contract) => {
                        return (
                          <Col
                            span={24}
                            style={{
                              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                              transition: "0.3s",
                            }}
                          >
                            <Row>
                              <Col span={24}>
                                <h3>
                                  Status:{" "}
                                  <Tag
                                    color="cyan"
                                    style={{ borderRadius: 25 }}
                                  >
                                    {contract.TCStatus}
                                  </Tag>
                                  {new Date(contract.TCToDate) < new Date() ? (
                                    <Tag
                                      color="red"
                                      style={{ borderRadius: 25 }}
                                    >
                                      Expired
                                    </Tag>
                                  ) : null}
                                </h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>
                                  Contract No.:{" "}
                                  <Tag
                                    color="green"
                                    style={{ borderRadius: 25 }}
                                  >
                                    {contract.TCNo}
                                  </Tag>
                                </h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Contract Date: {contract.TCDate}</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Valid From: {contract.TCFromDate}</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Valid Till: {contract.TCToDate}</h3>
                              </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ padding: 10 }}>
                              {(contract.RentalTCUnits || []).map(
                                (rtc, rtcIndex) => {
                                  if (
                                    (rtc.Unit || {}).UnitNo &&
                                    (rtc.Unit.Building || {}).BuildingName
                                  )
                                    return (
                                      <Col
                                        lg={12}
                                        md={24}
                                        sm={24}
                                        xs={24}
                                        style={{
                                          boxShadow:
                                            "0 4px 8px 0 rgba(0,0,0,0.4)",
                                          transition: "0.3s",
                                          padding: 10,
                                        }}
                                      >
                                        <Row>
                                          <Col span={24}>
                                            <h3>
                                              Building:{" "}
                                              {rtc.Unit.Building.BuildingName}
                                            </h3>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={24}>
                                            <h3>Unit: {rtc.Unit.UnitNo}</h3>
                                          </Col>
                                        </Row>
                                      </Col>
                                    );
                                  return null;
                                }
                              )}
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : null}
              </Card>
            </Col>
          ) : null}
          <Col
            {...(this.state.contactInfo.ContactID
              ? { xs: 24, sm: 24, md: 24, lg: 14 }
              : { xs: 24, sm: 24, md: 24, lg: 24 })}
          >
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => this.displayContactInfo(record),
                };
              }}
              style={{
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                transition: "0.3s",
                borderRadius: 20,
                width: "100%",
              }}
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 290 }}
              pagination={{
                size: "small",
                disabled: false,
                pageSize: this.state.tableData.pageSize,
                showQuickJumper: true,
                showSizeChanger: true,
                // total: this.state.tableData.list.length,
                total: this.state.tableData.total,
                onChange: (page, pageSize) => {
                  let state = this.state;
                  state.tableData.currentPage = page;
                  state.tableData.pageSize = pageSize;
                  this.setState(state, this.onSearch);
                },
              }}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(Contact);
